export default __webpack_public_path__ + "1e52fb8b113ee4a962d928dc36db6c9b.svg";